export const icons = [
  { name: 'zones', route: 'zones' },
  { name: 'warning', route: 'warning' },
  { name: 'vehicle-car', route: 'directions_car' },
  { name: 'electric_motorcycle', route: 'electric_moped' },
  { name: 'vehicle-motorcycle', route: 'moped' },
  { name: 'emergency_home', route: 'emergency_home' },
  { name: 'vehicle-small-van', route: 'local_shipping_small' },
  { name: 'vehicle-large-van', route: 'local_shipping' },
  { name: 'supervised_user_circle', route: 'supervised_user_circle' },
  { name: 'car', route: 'directions_car' },
  { name: 'add_hub', route: 'add_hub' },
  { name: 'add_general', route: 'add_general' },
  { name: 'delete_trashcan', route: 'delete-trashcan' },
  { name: 'remove_person', route: 'remove_person' },
  { name: 'add_person', route: 'add_person' },
  { name: 'edit', route: 'edit' },
  { name: 'driver_icon_blue', route: 'driver_icon_blue' },
  { name: 'driver_icon_online', route: 'driver_icon_online' },
  { name: 'driver_icon_offline', route: 'driver_icon_offline' },
];
